// extracted by mini-css-extract-plugin
export default {"juxtapose":"Juxtapose_juxtapose__O3RfO","juxtaposeContainer":"Juxtapose_juxtaposeContainer__2Mmwn","description":"Juxtapose_description__LOnQF"};